import React from "react";
import styled from "@emotion/styled";
import Element from "@whalecloud/page-builder-core/components/Element";

const ColumnContainer = styled("div")({
  position: "relative",
  flex: "1 100%",
  boxSizing: "border-box",
  height: "100%",
  width: "100%",
  zIndex: 20,
  display: "flex"
});

const BodyCell = (props: any) => {
  const { element } = props;
  return (
    <ColumnContainer style={{ justifyContent: "center" }}>
      <Element id={element.id} />
    </ColumnContainer>
  );
};

export default React.memo(BodyCell);
